"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XRayServiceNS = void 0;
var XRayServiceNS;
(function (XRayServiceNS) {
    XRayServiceNS.X_RAY_SERVICE_ID = Symbol.for("XRayService");
})(XRayServiceNS = exports.XRayServiceNS || (exports.XRayServiceNS = {}));
//# sourceMappingURL=x-ray.types.js.map